module.exports = __webpack_public_path__ + "img/07冯强.72c2dda2.png";